export enum SeoEvent {
  SELECT_PROMOTION = 'select_promotion',
  VIEW_PROMOTION = 'view_promotion',
  PURCHASE = 'purchase',
  REFUND_ORDER = 'refund',
  SIGN_UP = 'sign_up',
  NEWSLETTER_SIGNUP = 'newsletter_signup',
  VIEW_ITEM_LIST = 'view_item_list',
  SELECT_ITEM = 'select_item',
  ADD_TO_CART = 'add_to_cart',
  BEGIN_CHECKOUT = 'begin_checkout',
  ADD_SHIPPING_INFO = 'add_shipping_info',
  ADD_PAYMENT_INFO = 'add_payment_info',
  VIEW_ITEM = 'view_item',
  REMOVE_FROM_CART = 'remove_from_cart',
  ADD_TO_WISHLIST = 'add_to_wishlist',
  VIEW_CART = 'view_cart',
  SEARCH = 'search',
  LOGIN = 'login',
  ADD_ZIP_CODE = 'add_zip_code',
  PAGE_VIEW = 'pageview'
}

export interface Ga4Item {
  product_id?: string
  item_name?: string
  item_id?: string
  price: number
  discount: number
  currency?: string
  item_brand?: string
  item_promotion: string
  item_available: string
  item_new: string
  item_adult_only: string
  index: number
  item_category?: string
  item_variant?: string
  item_list_name?: string
  quantity: number
  creative_name: string | undefined
  promotion_id: string | undefined
}
